const api = {
	// 查询应用详情
	getServiceModuleApp: '/servicemoduleapp/getServiceModuleApp',
	// 获取系统管理员信息
	getSysAdmins: '/OAAuthorization/getSysAdmins',
	// 获取有应用管理权限的用户
	getHasAppManagePrivilegesUsers: '/OAAuthorization/getHasAppManagePrivilegesUsers',
	// 获取权限管理规则列表
	getOperationAuthorizations: '/OAAuthorization/getOperationAuthorizations',
	// 获取当前公司所有部门
	getDepartments: '/org/getDepartments',
	// 获取用户被授权的项目
	getAuthorizedCommunities: '/OAAuthorization/getAuthorizedCommunities',
};

export {
	api,
};
